import { useIntl } from 'react-intl';
import { AttachmentsResponse, Text } from '../../../../../../../UILibrary';
import { supportedFileTypesForPreview } from '../../../config/digitalSampling.config';
import { PdfContent } from '../PdfContent';
import { UnsuportedFileView } from './unsuportedView/UnsuportedFileView';
import { definedTranslation } from '../../../i18n';

type PreviewFileViewerProps = {
  file: AttachmentsResponse['items'][number] | null;
};

export function PreviewFileViewer({ file }: PreviewFileViewerProps) {
  const t = useIntl();
  /**
   * Handle different file types and render appropriate components
   * currently, supports only PDF files.
   */
  if (!file) {
    return (
      <Text>
        {t.formatMessage(definedTranslation.previewFiles.noFileSelected)}
      </Text>
    );
  }

  if (!supportedFileTypesForPreview.includes(file.type)) {
    return <UnsuportedFileView fileName={file?.name} fileType={file?.type} />;
  }

  return <PdfContent selectedFile={file} />;
}
